import { simple } from 'acorn-walk'

import { t } from './utils'

import type {
  AnyNode,
  DoWhileStatement,
  ForStatement,
  WhileStatement
} from 'acorn'

const LOOP_GUARD = '__r_loopGuard'
const LOOP_PREFIX = '__r_loop'
const LOOP_LIMIT = 100_000
let loopCounter: number
let loopNames: string[]

export function transformLoopGuard<T extends AnyNode>(node: T): T

export function transformLoopGuard(node: AnyNode): AnyNode {
  loopCounter = 0
  loopNames = []
  simple(node, {
    DoWhileStatement(node: DoWhileStatement) {
      const loopName = createLoopName()
      loopNames.push(loopName)
      node.body = wrapLoopBody(loopName, node.body)
    },
    ForStatement(node: ForStatement) {
      const loopName = createLoopName()
      loopNames.push(loopName)
      node.body = wrapLoopBody(loopName, node.body)
    },
    WhileStatement(node: WhileStatement) {
      const loopName = createLoopName()
      loopNames.push(loopName)
      node.body = wrapLoopBody(loopName, node.body)
    }
  })
  if (loopNames.length > 0) {
    simple(node, {
      Program(node) {
        node.body.unshift(
          ...loopNames.map((name) => createLoopDeclaration(name))
        )
        node.body.unshift(createLoopFunction())
      }
    })
  }
  return node
}

function createLoopCheck(loopName: string) {
  return t.expressionStatement(
    t.callExpression(t.identifier(LOOP_GUARD), [
      t.updateExpression('++', t.identifier(loopName))
    ])
  )
}

function createLoopDeclaration(loopName: string) {
  return t.variableDeclaration('let', [
    t.variableDeclarator(t.identifier(loopName), t.literal(0))
  ])
}

function createLoopFunction() {
  return t.functionDeclaration(
    t.identifier(LOOP_GUARD),
    [t.identifier('counter')],
    t.blockStatement([
      t.ifStatement(
        t.binaryExpression('>', t.identifier('counter'), t.literal(LOOP_LIMIT)),
        t.throwStatement(
          t.newExpression(t.identifier('Error'), [t.literal('CycleMaxLimit')])
        )
      )
    ])
  )
}

function createLoopName() {
  return `${LOOP_PREFIX}_${loopCounter++}`
}
function wrapLoopBody(loopName: string, loopBody: AnyNode) {
  if (t.isBlockStatement(loopBody)) {
    loopBody.body.unshift(createLoopCheck(loopName))
    return loopBody
  } else {
    return t.blockStatement([createLoopCheck(loopName), loopBody])
  }
}
